var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.473,
  y: 0.5,
  stroke: "currentColor",
  rx: 15.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.666 8h-9.334A3.334 3.334 0 0 0 9 11.333v9.334A3.334 3.334 0 0 0 12.332 24h9.334a3.333 3.333 0 0 0 3.333-3.333v-9.334A3.333 3.333 0 0 0 21.666 8m-7.334 12.667h-2v-7.334h2zm-1-8.179a1.17 1.17 0 0 1-1.166-1.176c0-.65.522-1.176 1.166-1.176s1.167.527 1.167 1.176c0 .65-.522 1.176-1.167 1.176m9 8.179h-2V16.93c0-2.246-2.666-2.076-2.666 0v3.736h-2v-7.334h2v1.177c.93-1.724 4.666-1.851 4.666 1.65z"
})));
export default SvgLinkedin;